export const isNewLoadingAnimationEnabled = document.querySelector("meta[name='new-loading-animation-feature-toggle']")?.getAttribute("content") === "true";
